import { Injectable } from '@angular/core';
import {BehaviorSubject, fromEvent} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class MouseEventsService {

  constructor() {
    this.initListeners();
  }

  private _isMouseDown = new BehaviorSubject(null);
  private _isMouseMove = new BehaviorSubject(null);

  get isMouseDown$(){
    return this._isMouseDown.asObservable();
  }
  get isMouseMove$(){
    return this._isMouseMove.asObservable();
  }

  private initListeners(){
    fromEvent(window, 'pointerdown').subscribe((event)=>{
      this._isMouseDown.next(event);
    });

    fromEvent(window, 'pointerup').subscribe(()=>{
      this._isMouseDown.next(false);
    });

    fromEvent(window, 'pointermove').subscribe((event)=>{
      this._isMouseMove.next(event);
    })
  }
}
